import React, { Component } from "react";
import * as s from "./SaveToLibraryBanner.module.scss";
import { Icons } from "src/libs/assets";
import { P, Button } from "src/views/shared/components";
import { inject, observer } from "mobx-react";
import { LibraryStore, UIStore } from "src/stores";
import { tx } from "src/libs/i18n";
import { ISingleWordpressArticle, ISingleWordpressDocument } from "src/models";

interface Props {
  post: ISingleWordpressArticle | ISingleWordpressDocument;
  title: string;
  uiStore?: UIStore;
  libraryStore?: LibraryStore;
}

@inject("uiStore", "libraryStore")
@observer
export class SaveToLibraryBanner extends Component<Props> {
  renderSaveButton = () => {
    const { post, uiStore, libraryStore } = this.props;
    return (
      <Button
        size={uiStore.isDesktop ? "medium" : "large"}
        color="red"
        className={s.saveToLibraryButton}
        onClick={() => libraryStore.onOpenModal(post)}
      >
        {tx("saveToLibrary.saveToLibrary")}
      </Button>
    );
  };

  renderMobileBanner = () => {
    const { title } = this.props;

    return (
      <>
        <h6 className={s.contentTitle}>{tx("saveToLibrary.saveToLibrary")}</h6>
        <div className={s.contentContainer}>
          <img
            src={Icons.library_small}
            alt={tx("icons.addToLibrary")}
            className={s.saveToLibraryIcon}
          />
          <P medium className={s.documentTitle}>
            {title}
          </P>
        </div>
        {this.renderSaveButton()}
      </>
    );
  };

  renderDesktopBanner = () => {
    const { title } = this.props;

    return (
      <div className={s.contentContainer}>
        <img
          src={Icons.library_small}
          alt={tx("icons.addToLibrary")}
          className={s.saveToLibraryIcon}
        />
        <P medium className={s.documentTitle}>
          {title}
        </P>
        {this.renderSaveButton()}
      </div>
    );
  };

  render() {
    const { post, uiStore } = this.props;
    if (!post) {
      return null;
    }

    return (
      <div className={s.saveToLibraryContainer}>
        {uiStore.isDesktop ? this.renderDesktopBanner() : this.renderMobileBanner()}
      </div>
    );
  }
}
